import { render, staticRenderFns } from "./edit-wrapper.vue?vue&type=template&id=7ca0e0a0&lang=pug"
import script from "./edit-wrapper.vue?vue&type=script&lang=js"
export * from "./edit-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports